export default __webpack_public_path__ + "img/bg-tab1and2_nav10-7de324ba.png";